/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSection12_LP_v4 = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSection12_LP_v4 = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);
    
    this.attachListeners();
  },
  attachListeners: function() {
    this.domDelegate.on('click', "[data-action='select-variant']", this.scrollToOptions.bind(this));
  },
  scrollToOptions: function(event, target) {
    let productContainer = document.querySelector(".Product_Section_V2.jsProduct");
    let variantSelectionTop = productContainer.offsetTop;
    let topPosition = variantSelectionTop - 27;
    $("html, body").animate({ scrollTop: topPosition+"px" }, 1000);    
  }
}

/******/ })()
;